import { useEffect, useRef, useState } from 'react';
import Search from "components/Direccion/Search";
import Form from "components/Direccion/Form";
import Table from "components/Direccion/Table";
import { useDireccion } from 'hooks/useDireccion';
import { useCliente } from 'hooks/useCliente';

import {Modal} from "react-bootstrap";
import SpinnerBootrap from 'components/SpinnerBootrap';
import SearchModal from 'components/Direccion/SearchModal';
import TableModal from 'components/Direccion/TableModal';
import Table2Modal from 'components/Direccion/Table2Modal';


function Direccion() {
    const [modalVincularCliente, setModalVincularCliente] = useState(false);
    const [selectedDireccion, setSelectedDireccion] = useState({})

    const {
        allDirecciones,
        direcciones,
        loading: loadingDireccion,
        page: pageDireccion,
        totalPages: totalPagesDireccion,
        status: statusDireccion,
        deleteDireccion,
        updateDireccion,
        createDireccion,
        getDirecciones,
        setPage: setPageDireccion,
        itemsPerPage,
        setItemsPerPage,
    } = useDireccion();


    const {
        getVinculedClients,
        clientes,
        vinculedClientes,
        loading: loadingCliente,
        page: pageCliente,
        totalPages: totalPagesCliente,
        status: statusCliente,
        getClientes,
        unlikeClient,
        likeClient,
        setPage: setPageCliente
    } = useCliente();


    const [isSearchedCliente, setIsSearchedCliente] = useState({
        search: '',
        option: '',
        state: false
    })

    
    const [isSearchedDireccion, setIsSearchedDireccion] = useState({
        search: '',
        option: '',
        state: false
    })

    const searchFormRef = useRef();

    const resetSearchDireccion = () => {
        setIsSearchedDireccion({
            search: '',
            option: '',
            state: false
        })
        searchFormRef.current?.reset();
    }

    const desvinculedClient = async ({cliente}) => {
        const mail = await unlikeClient({direccion: selectedDireccion, cliente});
        if(mail){
            await getVinculedClients({direccion: selectedDireccion,  mail})
            await getDirecciones({})
        }
    }

    const vinculedClient = async ({cliente}) => {
        const mail = await likeClient({direccion: selectedDireccion, cliente});
        console.log({
            mail
        })
        if(mail){
            await getVinculedClients({direccion: selectedDireccion,  mail})
            await getDirecciones({})
        }
    }

    const handleHideModalVincularCliente = () => {
        setSelectedDireccion({});
        setModalVincularCliente(false);
    }
    
    useEffect(() => {
        if (statusDireccion !== 401 || statusCliente !== 401) return
        localStorage.removeItem('token')
        window.location.href = "/login"
    }, [statusDireccion, statusCliente])

    return (
        <div className="container">
            <div className="row my-md-4">
                <h4 className="d-flex justify-content-center">Gestor de Direcciones</h4>
                <div className="col-12">
                    <Search 
                        getDirecciones={getDirecciones}
                        setIsSearched={setIsSearchedDireccion}
                        formRef={searchFormRef}
                    />
                </div>
                <div className="col-12">
                    <Form createDireccion={createDireccion} updateDireccion={updateDireccion} setIsSearched={setIsSearchedDireccion} />
                </div>
                <div className="col-12">
                    {loadingDireccion && <SpinnerBootrap />}
                    <Table 
                        setSelectedDireccion={setSelectedDireccion} 
                        getVinculedClients={getVinculedClients} 
                        setModalVincularCliente={setModalVincularCliente} 
                        direcciones={direcciones} 
                        getDirecciones={getDirecciones} 
                        deleteDireccion={deleteDireccion} 
                        totalPages={totalPagesDireccion} 
                        setPage={setPageDireccion} 
                        page={pageDireccion} 
                        isSearched={isSearchedDireccion} 
                        setIsSearched={setIsSearchedDireccion}
                        hasSearched={isSearchedDireccion.state}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        resetSearch={resetSearchDireccion}
                        totalDirecciones={allDirecciones.length ?? 0}
                    />
                </div>
            </div>

            <Modal show={modalVincularCliente} onHide={handleHideModalVincularCliente}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Clientes</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <div className="col-12">
                        <SearchModal getClientes={getClientes} setIsSearched={setIsSearchedCliente}/>
                    </div>
                    <div className="col-12">
                        {loadingCliente && <SpinnerBootrap/>}
                        <TableModal vinculedClient={vinculedClient} clientes={clientes} getClientes={getClientes} totalPages={totalPagesCliente} setPage={setPageCliente} page={pageCliente} isSearched={isSearchedCliente} setIsSearched={setIsSearchedCliente} />                        
                    </div>
                    
                    <div className="col-12">
                        {loadingCliente && <SpinnerBootrap/>}
                        
                        <Table2Modal
                            vinculedClientes={vinculedClientes}
                            desvinculedClient={desvinculedClient} 
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    )
}

export default Direccion